// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Loading_wrapper__3AjXP","loaderTextContainer":"Loading_loaderTextContainer__33cGi","loaderText":"Loading_loaderText__eWwC-"};